import { ModelID } from '@core/shared/ModelID';
import { Cancellable } from '@infrastructure/axios';
import { IInvoiceService } from '../../types';

export default class DownloadInvoiceByIdUseCase extends Cancellable {
  constructor(private service: IInvoiceService) {
    super();
    this.service = service;
  }

  async execute(invoiceId: ModelID): Promise<any> {
    const invoice = await this.service.downloadInvocieById(invoiceId, this.controller);
    return invoice  
  }
}
